import ViewportWatcher from '../../_lib/viewport-watcher';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

gsap.registerPlugin(ScrollTrigger)

export default class PinSection {
  ViewportWatcher: ViewportWatcher;

  constructor() {
    this.sectionsPin = document.querySelectorAll('.pin-section');
    if (this.sectionsPin.length < 1) return;
    this.ViewportWatcher = new ViewportWatcher();
    this.init()
    this.initResizeWatcher();
  }

  init() {
    const vw = (coef) => window.innerWidth * (coef / 100)
    const vh = (coef) => window.innerHeight * (coef / 100)

    let sectionsAll = document.querySelectorAll('.section')

    this.sectionsPin.forEach(section => {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top +=65px",
          end: "bottom +=65px",
          pin: true,
          scrub: true,
          pinSpacing: false
        }
      })
    });

    sectionsAll.forEach(section => {
      if (section.querySelector('.cover__image--a')) {
        let imgA = section.querySelector('.cover__image--a')
        let imgB = section.querySelector('.cover__image--b')

        let tlTwoImgs = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "+=100%",
            scrub: true
          }
        })

        tlTwoImgs.from(imgA, {
          xPercent: -100
        })
        tlTwoImgs.from(imgB, {
          xPercent: 100
        }, "<")
      }

      if (section.querySelector('.box--moving')) {
        let box = section.querySelector('.box--moving')
        let tlBox = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top center",
            scrub: true
          }
        })

        tlBox.fromTo(box, {
          y: vh(100)
        }, {
          y: vh(-100)
        })
      }
    });
  }

  initResizeWatcher() {
    window.addEventListener('viewport:resized', () => {
      ScrollTrigger.refresh();
    });
  }
}
